import { depuisQuand, jourDUnInstant } from '../datesEnMots';

/**
 * Les mots du compte de la session (chantier parametres-du-compte, ticket 03) : les onglets
 * Compte, IA branchée et Mes données de Paramètres (maquette du carnet `parametres.html`), et la
 * page où mène le lien du mail « Supprimer ton compte ». Les noms des onglets sont dans
 * `parametres.ts`, « Sortir » dans `cadre.ts`.
 */

/* ── Compte ── */

export const E_MAIL_DU_COMPTE = 'E-mail';
export const SANS_E_MAIL = 'aucun';
export const SESSION_ACTIVE_MAINTENANT = 'active maintenant';
export const CETTE_SESSION = 'cette session';
export const COUPER_LA_SESSION = 'couper';
export const couperLaSession = (appareil: string) => `Couper la session ${appareil}`;

/** La dernière activité d'une session, la dernière utilisation d'une clé : « il y a 2 h ». */
export function depuisQuandEnMots(iso: string, maintenant = new Date()): string {
  const quand = depuisQuand(iso, maintenant);
  if (quand.sorte === 'dans_l_heure') return 'dans l’heure';
  if (quand.sorte === 'heures') return `il y a ${quand.heures} h`;
  return `le ${quand.jour}`;
}

/* ── IA branchée ── */

export const AUCUNE_IA_BRANCHEE = 'Aucune IA n’est branchée à ton Nextilt.';
export const REVOQUER = 'Révoquer';
export const revoquerLaCle = (nom: string) => `Révoquer la clé ${nom}`;
export const CONFIRMATION_DE_LA_REVOCATION = 'Claude ne pourra plus lire ni écrire dans ton Nextilt.';
export const GARDER_LA_CLE = 'Garder';

/** Ce qu'on sait d'une clé, sous son nom : sa création, sa dernière utilisation, sa révocation. */
export function viesDUneCle(
  cle: { creeLe: string; derniereUtilisation: string | null; revoqueeLe: string | null },
  maintenant = new Date()
): string {
  const creee = `créée le ${jourDUnInstant(cle.creeLe, maintenant)}`;
  if (cle.revoqueeLe !== null) return `${creee} · révoquée le ${jourDUnInstant(cle.revoqueeLe, maintenant)}`;
  const utilisee = cle.derniereUtilisation === null ? 'jamais utilisée' : `utilisée ${depuisQuandEnMots(cle.derniereUtilisation, maintenant)}`;
  return `${creee} · ${utilisee}`;
}

/* ── IA branchée : les connexions de Claude (chantier connecteur-claude, ticket 04) ── */

export const CONNEXIONS_DE_CLAUDE = 'Connexions de Claude';
export const AUCUNE_CONNEXION_DE_CLAUDE =
  'Aucune connexion de Claude. Pour en ouvrir une, ajoute Nextilt dans les connecteurs de claude.ai.';
export const COUPER_LA_CONNEXION = 'Couper';
export const couperLaConnexion = (nom: string) => `Couper la connexion ${nom}`;
export const CONFIRMATION_DE_LA_COUPURE =
  'Claude n’aura plus accès à ton Nextilt par cette connexion, tout de suite. Pour la rouvrir, il faudra reconnecter Nextilt dans Claude.';
export const GARDER_LA_CONNEXION = 'Garder';

/** Ce qu'on sait d'une connexion, sous le nom de son client : son ouverture, sa dernière utilisation. */
export function viesDUneConnexion(connexion: { creeLe: string; derniereUtilisation: string | null }, maintenant = new Date()): string {
  const ouverte = `ouverte le ${jourDUnInstant(connexion.creeLe, maintenant)}`;
  const utilisee =
    connexion.derniereUtilisation === null ? 'jamais utilisée' : `utilisée ${depuisQuandEnMots(connexion.derniereUtilisation, maintenant)}`;
  return `${ouverte} · ${utilisee}`;
}

/* ── Mes données ── */

export const EXPORTER_TOUT = 'Exporter tout';
export const SUPPRIMER_MON_COMPTE = 'Supprimer mon compte';
export const CONFIDENTIALITE = 'Confidentialité';
export const CE_QUI_EST_GARDE = ' : ce qui est gardé, pourquoi, combien de temps.';
export const confirmationDeLaSuppression = (email: string | null) =>
  `Un mail va partir vers ${email ?? 'ton adresse'}. Son lien vaut une heure : il ouvre une dernière page avant de tout effacer.`;
export const ENVOYER_LE_LIEN = 'Envoyer le lien';
export const GARDER_MON_COMPTE = 'Garder mon compte';
export const REGARDE_TA_BOITE_MAIL = 'Regarde ta boîte mail : le lien vaut une heure, et une seule fois.';
export const REFUS_DU_PREMIER_COMPTE = 'Ton compte, le premier, se supprime depuis ton ordinateur, par la commande.';
export const REFUS_DU_DERNIER_COMPTE = 'C’est le dernier compte de Nextilt : il ne se supprime pas depuis l’app.';
export const REFUS_SANS_RAISON = 'Ce compte ne se supprime pas depuis l’app.';
export const UN_INSTANT = 'Un instant';
export const PAS_DE_REPONSE = 'Quelque chose n’a pas répondu. Réessaie.';
export const GESTE_SANS_RESEAU = 'Pas de réseau. Ce geste a besoin d’en avoir.';
export const TROP_DE_TENTATIVES = 'Trop de tentatives. Laisse passer quelques minutes.';

/* ── La page du lien, `/supprimer-mon-compte` ── */

export const SUPPRIMER_MON_COMPTE_QUESTION = 'Supprimer mon compte ?';
export const CE_QUI_PARTIRA =
  'Tout partira, sans retour : tes projets et toutes leurs bulles, leurs liens, tes journées préparées, tes post-it et tes listes, tes clés d’accès, les connexions de Claude et tes sessions.';
export const SUPPRIMER_DEFINITIVEMENT = 'Supprimer définitivement';
export const COMPTE_SUPPRIME = 'Ton compte est supprimé';
export const TOUT_EST_PARTI = 'Tout ce qu’il contenait est parti.';
export const REVENIR_A_LA_PRESENTATION = 'Revenir à la présentation';
export const REVENIR_A_L_APP = 'Revenir à l’app';
